module.exports = __webpack_public_path__ + "img/Lightbrown.50ec08d0.png";